import { Injectable } from '@angular/core';
import { IAppState } from '@myStore/app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  EAccountantsViewActions,
  GetCardsFailure,
  GetCardsRequest,
  GetCardsSuccess,
} from '@myStore/accountants/view/accountants-view.actions';
import { AccountantsViewService } from '@services/accountant-view/accountants-view.service';

@Injectable()
export class AccountantsViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _accountantsViewService: AccountantsViewService
  ) {}
  getAllCardsList = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetCardsRequest>(EAccountantsViewActions.GetCardsRequest),
        switchMap(() => {
          return this._accountantsViewService.getAllCards().pipe(
            map(data => {
              this._store.dispatch(new GetCardsSuccess(data));
            }),
            catchError(err => {
              this._store.dispatch(new GetCardsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
